import { useContext } from "react"

// components
import { Container, Paper, Grid, IconButton } from "@material-ui/core"
import { LoadingBig } from "../../shared/Loading/LoadingBig"
import AddIcon from "@material-ui/icons/Add"
import { PitcherTable } from "./PitcherTable/PitcherTable"

// contexts
import { GlobalsContext } from "../../context/GlobalsContext"
import { PitchingPageContext } from "./PitchingPage"

export const ActiveTab = () => {
	const { user } = useContext(GlobalsContext)
	const { loading, players, openNewPitcherModal } =
		useContext(PitchingPageContext)

	if (loading) {
		return <LoadingBig />
	}

	return (
		<Container className="tab-container">
			<Grid spacing={0} container component={Paper}>
				<Grid item xs={9} className="pitching-roster-table-title">
					<span>Active Pitchers</span>
				</Grid>
				{user!.admin && (
					<Grid item xs={3} className="pitching-roster-table-add">
						<IconButton onClick={openNewPitcherModal}>
							<AddIcon />
						</IconButton>
					</Grid>
				)}
				<Grid item xs={12}>
					<PitcherTable
						players={players.filter(
							(pitcher) => pitcher.pitcher && pitcher.active
						)}
					/>
				</Grid>
			</Grid>
		</Container>
	)
}
